module.exports = __webpack_public_path__ + "img/outofpluto.d4eaf8f5.png";